"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetAndResetTradePwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var SetAndResetTradePwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SetAndResetTradePwd, _super);
    function SetAndResetTradePwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '设置和重置交易密码接口';
        _this.code = '101016';
        _this.desc = '设置和重置交易密码接口';
        _this.requestParams = new password_1.SetAndResetTradePwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SetAndResetTradePwd;
}(service_1.BaseService));
exports.SetAndResetTradePwd = SetAndResetTradePwd;
//# sourceMappingURL=setAndResetTradePwd.js.map